var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvBetsP(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.83229 6.92708C2.94062 6.43542 2.33229 5.92708 2.33229 5.13542C2.33229 4.22708 3.17396 3.59375 4.58229 3.59375C6.06562 3.59375 6.61562 4.30208 6.66562 5.34375H8.50729C8.44896 3.91042 7.57396 2.59375 5.83229 2.16875V0.34375H3.33229V2.14375C1.71562 2.49375 0.415625 3.54375 0.415625 5.15208C0.415625 7.07708 2.00729 8.03542 4.33229 8.59375C6.41562 9.09375 6.83229 9.82708 6.83229 10.6021C6.83229 11.1771 6.42396 12.0938 4.58229 12.0938C2.86562 12.0938 2.19063 11.3271 2.09896 10.3438H0.265625C0.365625 12.1687 1.73229 13.1937 3.33229 13.5354V15.3438H5.83229V13.5521C7.45729 13.2437 8.74896 12.3021 8.74896 10.5938C8.74896 8.22708 6.72396 7.41875 4.83229 6.92708Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvBetsP);
export default __webpack_public_path__ + "static/media/ev-bets-p.d770cc8aad2a324fd8bbf7e644fc0fb4.svg";
export { ForwardRef as ReactComponent };